var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5927 18.0637H5.34204C5.17628 18.0637 5.01731 17.9979 4.9001 17.8807C4.78289 17.7635 4.71704 17.6045 4.71704 17.4387V3.68872C4.71704 3.52296 4.78289 3.36399 4.9001 3.24678C5.01731 3.12957 5.17628 3.06372 5.34204 3.06372H12.8427L17.2177 7.43872V17.4387C17.2177 17.5208 17.2015 17.6021 17.1701 17.6779C17.1387 17.7537 17.0926 17.8226 17.0346 17.8807C16.9766 17.9387 16.9077 17.9847 16.8318 18.0161C16.756 18.0476 16.6747 18.0637 16.5927 18.0637Z",
    stroke: "#677791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8425 3.06372V7.43872H17.2182",
    stroke: "#677791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46753 11.1887H13.4675",
    stroke: "#677791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46753 13.6887H13.4675",
    stroke: "#677791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileText);
export default __webpack_public_path__ + "static/media/FileText.92fed35538ec8d9e2b31982549403210.svg";
export { ForwardRef as ReactComponent };